import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    cursor: 'default'
  },

  bold: {}
}))

export default useStyles
